import { DomUtils } from './utils';

class Swipers {
    constructor(Swiper) {
        if (typeof Swiper == 'undefined') {
            return;
        }

        this.viewportWidth = DomUtils.getViewportWidth();
        this.createSwiperTeam();
        this.createSwiperServices();
        this.createSwiperBadges();
        this.createSwiperRecentPosts();
        this.createSwiperProces();
        this.createSwiperQuotes();
    }

    createSwiperQuotes() {
        const els = document.querySelectorAll('.quotes-swiper');
        if (!els.length) return;

        els.forEach((el) => {
            const wrapper = el.closest('.quotes');

            new Swiper(el, {
                slidesPerView: 1.06,
                spaceBetween: 20,
                breakpoints: {
                    600: {
                        slidesPerView: 2.4
                    }
                },
                navigation: {
                    nextEl: wrapper.querySelector('.swiper-next'),
                    prevEl: wrapper.querySelector('.swiper-prev')
                }
            });
        });
    }

    createSwiperBadges() {
        const els = document.querySelectorAll('.badges-swiper[data-mobile-swiper]');
        if (!els.length || this.viewportWidth >= 600) return;

        els.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1.3,
                spaceBetween: 30,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true
                }
            });
        });
    }

    createSwiperServices() {
        const els = document.querySelectorAll('.services-swiper[data-mobile-swiper]');
        if (!els.length || this.viewportWidth >= 600) return;

        els.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true
                }
            });
        });
    }

    createSwiperRecentPosts() {
        const els = document.querySelectorAll('.recent-posts-swiper[data-mobile-swiper]');
        if (!els.length || this.viewportWidth >= 600) return;

        els.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true
                }
            });
        });
    }

    createSwiperProces() {
        const els = document.querySelectorAll('.steps[data-mobile-swiper]');
        if (!els.length || this.viewportWidth >= 600) return;

        els.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1.4,
                spaceBetween: 16,
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true
                }
            });
        });
    }

    createSwiperTeam() {
        const els = document.querySelectorAll('.team-swiper[data-mobile-swiper]');
        if (!els.length || this.viewportWidth >= 600) return;

        els.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1.3,
                spaceBetween: 20,
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true
                }
            });
        });
    }
}
new Swipers(Swiper);
